import React, { MouseEvent, ReactElement, ReactNode } from 'react';

import { getClassNames } from '../../../utils/util';

import useTheme from '../../../hooks/use-theme/useTheme';

import './button.scss';

type Props = {
  text: string;
  disabled?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  icon?: ReactNode;
  auth?: boolean;
  secondary?: boolean;
};

const Button = ({ text, disabled = false, onClick, icon, auth = false, secondary = false }: Props): ReactElement => {
  const { pps } = useTheme();

  return (
    <button className={getClassNames('button', { auth, secondary, pps })} disabled={disabled} onClick={onClick}>
      {icon && icon}
      {text}
    </button>
  );
};

export default Button;
